import { Show } from 'solid-js';
import delve from 'dlv';
import Radio from '~/components/ui/Radio';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';
import styles from './multiApplication.module.scss';
import ApplicationTypeContent from './ApplicationTypeContent';
import { useFormContext } from '~/components/Form/FormContext';
import { ApplicationTypeEnum } from '~/api';

export default function ApplicationType() {
  const formAccessors = useFormContext();

  const fieldError = () => {
    const error = delve(formAccessors?.errors(), 'applicationType', '');
    if (Array.isArray(error)) return error;
    return error ? [error] : [];
  };

  return (
    <div class="flex flex-col mb-2 gap-2">
      <span class="text-sm font-normal">
        <Localized
          translationKey={getTranslationKey(`application_type_label`)}
        />
      </span>
      <div class={styles.cardTypeRadioBtnGrp}>
        <Radio
          name="applicationType"
          options={[
            {
              label: (
                <ApplicationTypeContent
                  type={ApplicationTypeEnum.WEB_APPLICATION}
                />
              ),
              value: ApplicationTypeEnum.WEB_APPLICATION,
              testId: 'create-application-modal-web-application-radio'
            },
            {
              label: (
                <ApplicationTypeContent
                  type={ApplicationTypeEnum.SINGLE_PAGE_APPLICATION}
                />
              ),
              value: ApplicationTypeEnum.SINGLE_PAGE_APPLICATION,
              testId: 'create-application-modal-single-page-application-radio'
            },
            {
              label: (
                <ApplicationTypeContent
                  type={ApplicationTypeEnum.NATIVE_APPLICATION}
                />
              ),
              value: ApplicationTypeEnum.NATIVE_APPLICATION,
              testId: 'create-application-modal-native-application-radio'
            }
          ]}
        />
      </div>
      <Show when={fieldError().length > 0}>
        <p class="text-error text-sm mt-1">{fieldError()[0]}</p>
      </Show>
    </div>
  );
}
